module.exports = __webpack_public_path__ + "img/hopital-sacre-coeur.d866f885.webp";